/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PageDataAdminStockManageUserListResVo } from './PageDataAdminStockManageUserListResVo';
import {
    PageDataAdminStockManageUserListResVoFromJSON,
    PageDataAdminStockManageUserListResVoFromJSONTyped,
    PageDataAdminStockManageUserListResVoToJSON,
    PageDataAdminStockManageUserListResVoToJSONTyped,
} from './PageDataAdminStockManageUserListResVo';

/**
 * 
 * @export
 * @interface ResponsePageDataAdminStockManageUserListResVo
 */
export interface ResponsePageDataAdminStockManageUserListResVo {
    /**
     * 接口状态码
     * @type {number}
     * @memberof ResponsePageDataAdminStockManageUserListResVo
     */
    code?: number;
    /**
     * 接口返回消息
     * @type {string}
     * @memberof ResponsePageDataAdminStockManageUserListResVo
     */
    message?: string;
    /**
     * 
     * @type {PageDataAdminStockManageUserListResVo}
     * @memberof ResponsePageDataAdminStockManageUserListResVo
     */
    data?: PageDataAdminStockManageUserListResVo;
}

/**
 * Check if a given object implements the ResponsePageDataAdminStockManageUserListResVo interface.
 */
export function instanceOfResponsePageDataAdminStockManageUserListResVo(value: object): value is ResponsePageDataAdminStockManageUserListResVo {
    return true;
}

export function ResponsePageDataAdminStockManageUserListResVoFromJSON(json: any): ResponsePageDataAdminStockManageUserListResVo {
    return ResponsePageDataAdminStockManageUserListResVoFromJSONTyped(json, false);
}

export function ResponsePageDataAdminStockManageUserListResVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResponsePageDataAdminStockManageUserListResVo {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'] == null ? undefined : json['code'],
        'message': json['message'] == null ? undefined : json['message'],
        'data': json['data'] == null ? undefined : PageDataAdminStockManageUserListResVoFromJSON(json['data']),
    };
}

export function ResponsePageDataAdminStockManageUserListResVoToJSON(json: any): ResponsePageDataAdminStockManageUserListResVo {
    return ResponsePageDataAdminStockManageUserListResVoToJSONTyped(json, false);
}

export function ResponsePageDataAdminStockManageUserListResVoToJSONTyped(value?: ResponsePageDataAdminStockManageUserListResVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'code': value['code'],
        'message': value['message'],
        'data': PageDataAdminStockManageUserListResVoToJSON(value['data']),
    };
}

